import React, { useState, useEffect } from 'react';
import {
    FormLabel,
    Button,
    MultiSelect,
    ToggleSmall,
} from 'carbon-components-react';
import { boolean, select, text, object } from '@storybook/addon-knobs';
import axios from "axios";
import i18n from "../../i18n";
import * as Constants from '../../requests/URLConstants'
import callPostApi from "../../requests/PostRequests";
import * as configConst from "../../config/Constants";
import * as workspaces from '../../config/WorkspaceConstants'


require("./_dashboard-filters.scss");


const sizes = {
    'Extra large size (xl)': 'xl',
    'Default size': undefined,
    'Small size (sm)': 'sm',
};
const types = {
    'Default (default)': 'default',
    'Inline (inline)': 'inline',
};
const directions = {
    'Bottom (default)': 'bottom',
    'Top ': 'top',
};

const multiselectprops = {
    id: text('MultiSelect ID (id)', 'carbon-multiselect-example'),
    light: boolean('Light variant (light)', false),
    useTitleInItem: boolean('Show tooltip on hover', false),
    type: select('UI type (Only for `<MultiSelect>`) (type)', types, 'default'),
    size: select('Field size (size)', sizes, undefined) || undefined,
    direction: select('Dropdown direction (direction)', directions, 'bottom'),
    invalid: boolean('Show form validation UI (invalid)', false),
    invalidText: text(
        'Form validation UI content (invalidText)',
        'Invalid Selection'
    ),
    warn: boolean('Show warning state (warn)', false),
    warnText: text(
        'Warning state text (warnText)',
        'Selecting more items may increase processing time'
    ),
    listBoxMenuIconTranslationIds: object(
        'Listbox menu icon translation IDs (for translateWithId callback)',
        {
            'close.menu': 'Close menu',
            'open.menu': 'Open menu',
            'clear.all': 'Clear all',
            'clear.selection': 'Clear selection',
        }
    ),
    selectionFeedback: select(
        'Selection feedback',
        ['top', 'fixed', 'top-after-reopen'],
        'top-after-reopen'
    )
};

const DashboardFilters = props => {

    // const [filterSelections, setFilterSelections] = useState(props.filterSelections);
    const [filterSelections, setFilterSelections] = useState();
    //const [disabledSelects, setDisabledSelects] = useState(props.disabledSelects);
    const [disabledSelectsSAP, setDisabledSelectsSAP] = useState(props.filterSelectionsSAP.franchise.length !== 0 ? false : true);
    const [disabledSelectsAutomation, setDisabledSelectsAutomation] = useState(props.filterSelectionsAutomation.franchise.length !== 0 ? false : true);
    const [disabledSelectsSalesforce, setDisabledSelectsSalesforce] = useState(props.filterSelectionsSalesforce && props.filterSelectionsSalesforce.franchise.length !== 0 ? false : true);

    const [clients, setClients] = useState(props.filterData && props.filterData.clients ? props.filterData.clients : []);
    const [alertSourceData, setAlertSourceData] = useState(props.filterData && props.filterData.alert_source ? props.filterData.alert_source : []);
    const [alertSystemNameData, setAlertSystemNameData] = useState(props.filterData && props.filterData.alert_system_name ? props.filterData.alert_system_name : []);
    const [franchiseItems, setFranchiseItems] = useState([]);
    const [assigneesDisable, setassigneeDisable] = useState(false);
    const [isAssignedTome, setAssignedTome] = useState(false);
    const [showSelectedFranchise, setShowSelectedFranchise] = useState(false);
    const [clientKey, setClientKey] = useState(true);
    const [alertSourceKey, setAlertSourceKey] = useState(true);
    const [alertSystemKey, setAlertSystemKey] = useState(true);
    const [alertSourceSystemDisable, setAlertSourceSystemDisable] = useState(props.filterSelectionsSAP.client.length !== 0 ? false : true);

    const FilterBy = i18n.t('filter.FilterBy');
    const franchise = i18n.t('filter.franchise');
    const Client = i18n.t('filter.Client');
    const Clientselection = i18n.t('filter.Clientselection');
    const IncidentStatus = i18n.t('filter.IncidentStatus');
    const Technology = i18n.t('filter.Technology');
    const Priority = i18n.t('filter.FilterPriority');
    const Chooseoptions = i18n.t('filter.Chooseoptions');
    const Addmorefilters = i18n.t('filter.Addmorefilters');
    const Apply = i18n.t('filter.Apply');
    const Clear = i18n.t('filter.Clear');
    const AssignedTo = i18n.t('filter.AssignedTo');
    const showIncident = i18n.t('filter.ShowIncident')
    const AssignmentGp = i18n.t('filter.AssignmentGp');
    const Status = i18n.t('filter.Status');
    const DeploymentModel = i18n.t('filter.DeploymentModel');
    const Geos = i18n.t('filter.Geos');
    const Competencies = i18n.t('filter.Competencies');
    const Resource = i18n.t('filter.Resource');
    const AutomataState = i18n.t('filter.AutomataState');
    const AutomataName = i18n.t('filter.AutomataName');
    const AutomataActivityName = i18n.t('filter.AutomataActivityName');
    const ItemStatusA1 = i18n.t('filter.ItemStatusA1');
    const JobId = i18n.t('filter.JobId');
    const BotID = i18n.t('filter.BotId');
    const QueueName = i18n.t('filter.QueueName');
    const BusinessComponent = i18n.t('filter.BusinessComponent');
    const LeadPlatform = i18n.t('filter.LeadPlatform');
    const SubArea = i18n.t('filter.SubArea');
    const BotName = i18n.t('filter.BotName');
    const ProcessName = i18n.t('filter.ProcessName');
    const RemediationType = i18n.t('filter.RemediationType');
    const OpenMenu = i18n.t('filter.OpenMenu');
    const AlertSource = i18n.t('filter.AlertSource');
    const SystemName = i18n.t('filter.SystemName');

    useEffect(() => {
        if (props.workspace === workspaces.automation_ops) {
            setFilterSelections(props.filterSelectionsAutomation);
            getClientData(props.filterSelectionsAutomation.franchise);

        }
        if (props.workspace === workspaces.sap_ops || props.workspace === workspaces.custom_ops) {
            setFilterSelections(props.filterSelectionsSAP);
            getClientData(props.filterSelectionsSAP.franchise);
            getInfraFiltersData();
            props.filterSelectionsSAP.client && getAlertData(props.filterSelectionsSAP.client);
        }

        if (props.workspace === workspaces.salesforce_ops) {
            setFilterSelections(props.filterSelectionsSalesforce);
            getClientData(props.filterSelectionsSalesforce.franchise);
        }

        // if (props.filterSelectionsAutomation.franchise.length !== 0 || props.filterSelectionsSAP.franchise.length !== 0) {
        //     setDisabledSelects({ 'client-select': false });
        // }
        if (props.filterSelectionsAutomation && props.filterSelectionsAutomation.franchise.length !== 0) {
            setDisabledSelectsAutomation(false);
        }
        else if (props.filterSelectionsSAP && props.filterSelectionsSAP.franchise.length !== 0) {
            setDisabledSelectsSAP(false);
        }
        else if (props.filterSelectionsSalesforce && props.filterSelectionsSalesforce.franchise.length !== 0) {
            setDisabledSelectsSalesforce(false);
        }
        // handleAssignedToMe(false);
        // if (props.filterSelections && props.filterSelections.assignee_email && props.filterSelections.assignee_email.length > 0) {
        //     setAssignedTome(true);
        // } else {
        //     setAssignedTome(false);
        // }
    }, [props]);

    useEffect(() => {
        changeFilterTooltip();
    }, []);

    useEffect(() => {
        if (showSelectedFranchise) {
            let selectedClientsList = [];
            selectedClientsList.push(clients.map((clientItem) => { return clientItem.name }));
            let selectedClients = filterSelections.client.filter(item => selectedClientsList[0].includes(item));
            setFilterSelections({ ...filterSelections, "client": selectedClients });
            setClientKey(!clientKey);
            props.dashboardType === "AlertManagement" && handleAlertClientSelection(selectedClients);
        }
    }, [clients])

    useEffect(() => {
        if (filterSelections && filterSelections.alert_source) {
            let selectedValues = alertSourceData.filter(item => filterSelections.alert_source.some(selecteditem => selecteditem === item.name)).map(key => key.name);
            setFilterSelections({ ...filterSelections, "alert_source": selectedValues });
            setAlertSourceKey(!alertSourceKey);
        }
    }, [alertSourceData]);

    useEffect(() => {
        if (filterSelections && filterSelections.alert_system_name) {
            let selectedValues = alertSystemNameData.filter(item => filterSelections.alert_system_name.some(selecteditem => selecteditem === item.name)).map(key => key.name);
            setFilterSelections({ ...filterSelections, "alert_system_name": selectedValues });
            setAlertSystemKey(!alertSystemKey);
        }
    }, [alertSystemNameData]);

    const changeFilterTooltip = () => {
        var parent = document.getElementById("dashboard-filter");
        var child = parent.getElementsByClassName("bx--list-box__menu-icon");
        for (let i = 0; i < child.length; i++) {
            let a = child[i].getElementsByTagName("title");
            a[0].innerHTML = OpenMenu;
        }
    };

    const handleFranchiseSelectionChange = (event) => {
        let franchiseLength = event.selectedItems.length;
        let oldFranchiseLength = filterSelections.franchise.length;
        if (oldFranchiseLength > franchiseLength) {
            setShowSelectedFranchise(true);
        }
        else setShowSelectedFranchise(false);
        var selectedValues = event.selectedItems.map(function (k, v) {
            return k.name;
        });
        let noOfFranchises = filterSelections.franchise.length;
        setFilterSelections({ ...filterSelections, "franchise": selectedValues });
        getClientData(selectedValues);

        if (selectedValues.length > 0) {
            //setDisabledSelects({ 'client-select': false });
            if (props.workspace === workspaces.automation_ops) {
                setDisabledSelectsAutomation(false);
            }
            else if (props.workspace === workspaces.sap_ops || props.workspace === workspaces.custom_ops) {
                setDisabledSelectsSAP(false);
            }
            else if (props.workspace === workspaces.salesforce_ops) {
                setDisabledSelectsSalesforce(false);
            }
        } else {
            let element = document.getElementById('client-select').getElementsByClassName('bx--list-box__selection bx--tag--filter bx--list-box__selection--multi')[0];
            element && element.click();
            //setDisabledSelects({ 'client-select': true });
            if (props.workspace === workspaces.automation_ops) {
                setDisabledSelectsAutomation(true);
            }
            else if (props.workspace === workspaces.sap_ops || props.workspace === workspaces.custom_ops) {
                setDisabledSelectsSAP(true);
            }
            else if (props.workspace === workspaces.salesforce_ops) {
                setDisabledSelectsSalesforce(true);
            }
        }
    };

    const getAlertData = (clients) => {

        callPostApi(Constants.GETALERTSOURCEFILTERS, { 'Content-Type': 'application/json' }, { clientsSelected: clients })
            .then(resp => {
                if (resp) {
                    let alert_source_List = [];
                    resp.forEach(element => {
                        let alert_source = {};
                        alert_source.name = element.key;
                        alert_source_List.push(alert_source);
                    });
                    setAlertSourceData(alert_source_List);
                }
            }).catch((error) => {
                console.error('Error:', error);
            });

        callPostApi(Constants.GETSYSTEMNAMEFILTERS, { 'Content-Type': 'application/json' }, { clientsSelected: clients })
            .then(resp => {
                if (resp) {
                    let alert_system_name_List = [];
                    resp.forEach(element => {
                        let alert_system_name = {};
                        alert_system_name.name = element.key;
                        alert_system_name_List.push(alert_system_name);
                    });
                    setAlertSystemNameData(alert_system_name_List);
                }
            }).catch((error) => {
                console.error('Error:', error);
            });

    }

    const getClientData = (franchiseSelections) => {
        let request = {};
        let filtersArray = [];
        if (franchiseSelections != null && franchiseSelections.length > 0) {
            filtersArray = franchiseSelections;
        }
        request.alertType = props.alertType;
        request.filtersArray = filtersArray;

        if (props.workspace === workspaces.automation_ops) {
            request.automation = workspaces.automation_ops;
        }
        if (props.workspace === workspaces.sap_ops || props.workspace === workspaces.custom_ops) {
            request.sap = workspaces.sap_ops;
        }

        if (props.workspace === workspaces.salesforce_ops) {
            request.salesforce = workspaces.salesforce_ops;
        }

        axios.all([
            callPostApi(Constants.GETCLIENTSURL, {
                'Content-Type': 'application/json'
            }, request).then(clientResponse => {
                if (clientResponse) {
                    return clientResponse;
                }
            }, function (err) {
                console.trace(err.message);
            }),
            //GETINFRAALERTSCLIENTSDATA to be called only in SAP space
            props.workspace === workspaces.sap_ops &&
            callPostApi(Constants.GETINFRAALERTSCLIENTSDATA, {
                'Content-Type': 'application/json'
            }, request).then(franchiseResponse => {
                if (franchiseResponse) {
                    return franchiseResponse;
                }
            }, function (err) {
                console.trace(err.message);
            })

        ]).then(axios.spread((clientResponse, franchiseResponse) => {
            let clientsList = [];
            if (clientResponse && clientResponse.aggregations && clientResponse.aggregations.filtered && clientResponse.aggregations.filtered.clients.buckets) {
                clientResponse.aggregations.filtered.clients.buckets.forEach(element => {
                    let client = {};
                    client.name = element.key;
                    clientsList.push(client);
                });
            }
            if (franchiseResponse && franchiseResponse.aggregations && franchiseResponse.aggregations.filtered && franchiseResponse.aggregations.filtered.clients.buckets && props.workspace === workspaces.sap_ops) {
                franchiseResponse.aggregations.filtered.clients.buckets.forEach(element => {
                    let client = {};
                    client.name = element.key;
                    clientsList.push(client);
                });
            }
            const uniqueClientNames = [...new Map(clientsList.map(item => [JSON.stringify(item), item])).values()];
            //console.log(clientsList, uniqueClientNames, "ClientNames");
            props.workspace === workspaces.sap_ops ? setClients(uniqueClientNames) : setClients(clientsList);
        }))
    }

    const getInfraFiltersData = () => {
        callPostApi(Constants.GETINFRAALERTSFILTERDATA, {
            'Content-Type': 'application/json'
        })
            .then(resp => {
                let franchiseList = [];
                if (resp && resp.aggregations && resp.aggregations.franchises && resp.aggregations.franchises.buckets) {
                    resp.aggregations.franchises.buckets.forEach(element => {
                        let franchise = {};
                        franchise.name = element.key;
                        franchiseList.push(franchise);
                    });
                }
                if (props && props.filterData && props.filterData.franchises) {
                    franchiseList.push(...props.filterData.franchises);
                }
                const uniqueFranchiseNames = [...new Map(franchiseList.map(item => [JSON.stringify(item), item])).values()];
                //  console.log(franchiseList,uniqueFranchiseNames, "Franchisenames");
                setFranchiseItems(uniqueFranchiseNames);
            }, function (err) {
                console.trace(err.message);
            });

    }

    const handleAlertClientSelection = (clientValues) => {
        getAlertData(clientValues);
        if (clientValues.length > 0) {
            setAlertSourceSystemDisable(false);
        }
        else {
            setAlertSourceSystemDisable(true);
            let sourceElement = document.getElementById('alert_source-select').getElementsByClassName('bx--list-box__selection bx--tag--filter bx--list-box__selection--multi')[0];
            let systemElement = document.getElementById('alert_system_name-select').getElementsByClassName('bx--list-box__selection bx--tag--filter bx--list-box__selection--multi')[0];
            sourceElement && sourceElement.click();
            systemElement && systemElement.click();
            setFilterSelections({ ...filterSelections, "client": [], "alert_source": [], "alert_system_name": [] });
        }
    }

    const handleSelectionChange = (type, event) => {
        var selectedValues = event.selectedItems.map(function (k, v) {
            return k.name;
        });

        switch (type) {
            case 'client-select':
                setFilterSelections({ ...filterSelections, "client": selectedValues });
                props.dashboardType === "AlertManagement" && handleAlertClientSelection(selectedValues);
                break;
            case 'technology-select':
                setFilterSelections({ ...filterSelections, "technology": selectedValues });
                break;
            case 'deployment-select':
                setFilterSelections({ ...filterSelections, "deployment_model": selectedValues });
                break;
            case 'geo-select':
                setFilterSelections({ ...filterSelections, "geo": selectedValues });
                break;
            case 'competency-select':
                setFilterSelections({ ...filterSelections, "competency": selectedValues });
                break;
            case 'priority-select':
                setFilterSelections({ ...filterSelections, "priority": selectedValues });
                break;
            case 'incident_status-select':
                setFilterSelections({ ...filterSelections, "incident_status": selectedValues });
                break;
            case 'assignee-select':
                if (!assigneesDisable) {
                    setFilterSelections({ ...filterSelections, "assignee": selectedValues, "assignee_email": [] });
                } else {
                    setFilterSelections({ ...filterSelections, "assignee": [] });
                }
                break;
            case 'assignment_group-select':
                setFilterSelections({ ...filterSelections, "assignment_group": selectedValues });
                break;
            case 'automata_state-select':
                setFilterSelections({ ...filterSelections, "automata_state": selectedValues });
                break;
            case 'buisness_component-select':
                setFilterSelections({ ...filterSelections, "buisness_component": selectedValues });
                break;
            case 'queue_name-select':
                setFilterSelections({ ...filterSelections, "queue_name": selectedValues });
                break;
            case 'job_id-select':
                setFilterSelections({ ...filterSelections, "job_id": selectedValues });
                break;
            case 'itemStatus_A1-select':
                setFilterSelections({ ...filterSelections, "itemStatus_A1": selectedValues });
                break;
            case 'status-select':
                setFilterSelections({ ...filterSelections, "status": selectedValues });
                break;
            case 'automata_name-select':
                setFilterSelections({ ...filterSelections, "automata_name": selectedValues });
                break;
            case 'automata_activity_name-select':
                setFilterSelections({ ...filterSelections, "automata_activity_name": selectedValues });
                break;
            case 'resource-select':
                setFilterSelections({ ...filterSelections, "resource": selectedValues });
                break;
            case 'bot_id-select':
                setFilterSelections({ ...filterSelections, "bot_id": selectedValues });
                break;
            case 'process_name-select':
                setFilterSelections({ ...filterSelections, "process_name": selectedValues });
                break;
            case 'remediation_type-select':
                setFilterSelections({ ...filterSelections, "remediation_type": selectedValues });
                break;
            case 'bpmn_user-select':
                setFilterSelections({ ...filterSelections, "bpmn_user": selectedValues });
                break;
            case 'bpmn_report-select':
                setFilterSelections({ ...filterSelections, "bpmn_report": selectedValues });
                break;
            case 'bpmn_report_type-select':
                setFilterSelections({ ...filterSelections, "bpmn_report_type": selectedValues });
                break;
            case 'alert_source-select':
                setFilterSelections({ ...filterSelections, "alert_source": selectedValues });
                break;
            case 'alert_system_name-select':
                setFilterSelections({ ...filterSelections, "alert_system_name": selectedValues });
                break;
            default:
        }
    };

    const handleFilterChange = () => {
        if (props.workspace === workspaces.automation_ops) {
            props.updateState('dashboardFilterSelectionsAutomation', filterSelections);
        }
        if (props.workspace === workspaces.sap_ops || props.workspace === workspaces.custom_ops) {
            props.updateState('dashboardFilterSelectionsSAP', filterSelections);
        }
        if (props.workspace === workspaces.salesforce_ops) {
            props.updateState('dashboardFilterSelectionsSalesforce', filterSelections);
        }
        props.updateState('alertFilterData_clients', clients);
        //props.updateState('disabledSelects', disabledSelects);
        props.handleClose();
    }

    const handleAssignedToMe = (e) => {
        //console.log("toggle click", e);
        let user = JSON.parse(localStorage.getItem('user'));
        if (e === true) {
            // if(document.querySelector('.bx--multi-select .bx--list-box__selection--multi')){
            //     document.querySelector('.bx--multi-select .bx--list-box__selection--multi').remove();
            // }
            setAssignedTome(true);
            setassigneeDisable(true);
            setFilterSelections({ ...filterSelections, "assignee_email": [user.username], "assignee": [] });
        } else {
            setAssignedTome(false)
            setassigneeDisable(false);
            setFilterSelections({ ...filterSelections, "assignee_email": [] });

        }
    }

    const populateInitalSelectedItems = (selections) => {
        let initialValues = [];
        if (selections) {
            selections.map(function (v) {
                initialValues.push({ "name": v });
            });
        }
        return initialValues;
    }

    const handleAssigneeChange = (event) => {

    };

    const clearAll = (e) => {
        setTimeout(() => {
            document.querySelectorAll('.bx--multi-select .bx--list-box__selection--multi').forEach(e => e.click());
        }, 0)
    };

    return (

        <div id="dashboard-filter" hidden={props.hidden} className="bx--grid bx--grid--full-width filter--page font-family">
            {props.workspace === workspaces.automation_ops && filterSelections ?

                <div className='filter-grid'>

                    {/* <div style={{ width: 300 }}>
                        <MultiSelect
                            {...multiselectprops}
                            id='select-assignee'
                            titleText={AssignedTo}
                            helperText=''
                            disabled={assigneesDisable}
                            label={Chooseoptions}
                            items={props.filterData.assignees ? props.filterData.assignees : []}
                            itemToString={(item) => (item ? item.name : '')}
                            initialSelectedItems={() => populateInitalSelectedItems(props.filterSelections.assignee)}
                            translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                            selectionFeedback={multiselectprops.selectionFeedback}
                            onChange={(e) => handleSelectionChange('assignee-select', e)}
                        />
                    </div>

                    <div className="toggle-filter margin-top-10px">
                        <div className="show-incident margin-right-10px">{showIncident}</div>
                        <ToggleSmall
                         aria-label="toggle button"
                         id="toggle-2"
                         labelText=""
                         toggled={isAssignedTome}
                         onToggle={(e) => handleAssignedToMe(e)}

                         />
                    </div> */}

                    <div className="multi-select-row">
                        {configConst.URL.includes(configConst.unilever) ? null :
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    id='select'
                                    titleText={franchise}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.franchises ? props.filterData.franchises : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.franchise)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={handleFranchiseSelectionChange}
                                />
                            </div>}
                        {configConst.URL.includes(configConst.unilever) ? null :

                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    id='client-select'
                                    key={clientKey}
                                    titleText={Client}
                                    helperText={Clientselection}
                                    disabled={disabledSelectsAutomation}
                                    placeholder={Chooseoptions}
                                    items={clients ? clients : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.client)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('client-select', e)}
                                />
                            </div>}
                        {props.dashboardType === "AutomationBusinessCatalogue" ? null :
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={Technology}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.technologies ? props.filterData.technologies : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.technology)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('technology-select', e)}
                                />
                            </div>
                        }
                        {configConst.URL.includes(configConst.unilever) || props.dashboardType === "AutomationBusinessCatalogue" ? null :
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={DeploymentModel}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.deployment_models ? props.filterData.deployment_models : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.deployment_model)} translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('deployment-select', e)}
                                />
                            </div>}
                        {props.dashboardType === "SchedulingEfficiency" || props.dashboardType === "Capacity" || props.dashboardType === "Execution" || props.dashboardType === "IncidentManagement"
                            || props.dashboardType === "SLA" || props.dashboardType === "Bot" || props.dashboardType === "Remediation"
                            || props.dashboardType === "QueueEfficiency" || props.dashboardType === "QueueManagement" || props.dashboardType === "TrustIndex" || props.dashboardType === "Execution" || props.dashboardType === "BusinessViewValueRealization" ?
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={configConst.URL.includes(configConst.unilever) ? LeadPlatform : Competencies}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.competencies ? props.filterData.competencies : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={filterSelections.competency ? filterSelections.competency.map(function (v) {
                                        return { "name": v };
                                    }) : []}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('competency-select', e)}
                                />
                            </div> : null}
                        {configConst.URL.includes(configConst.unilever) ?
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={SubArea}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.buisness_component ? props.filterData.buisness_component : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.buisness_component)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('buisness_component-select', e)}
                                />
                            </div>
                            :
                            props.dashboardType === "Execution" || props.dashboardType === "BusinessViewValueRealization" ?
                                <div className="multi-select-filter">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        titleText={BusinessComponent}
                                        helperText=''
                                        disabled={false}
                                        placeholder={Chooseoptions}
                                        items={props.filterData && props.filterData.buisness_component ? props.filterData.buisness_component : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(filterSelections.buisness_component)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('buisness_component-select', e)}
                                    />
                                </div> : null
                        }
                        {props.dashboardType === "SchedulingEfficiency" || props.dashboardType === "Capacity" || props.dashboardType === "Execution" || props.dashboardType === "Bot" ?
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={Geos}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.geos ? props.filterData.geos : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.geo)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('geo-select', e)}
                                />
                            </div> : null}

                        {props.dashboardType === "Capacity" || props.dashboardType === "Execution" || props.dashboardType === "Bot" || props.dashboardType === "SchedulingEfficiency" || props.dashboardType === "Remediation"
                            || props.dashboardType === "QueueEfficiency" || props.dashboardType === "QueueManagement" || props.dashboardType === "TrustIndex" || props.dashboardType === "BusinessViewValueRealization"
                            ?
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={Priority}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.priorities ? props.filterData.priorities : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.priority)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('priority-select', e)}
                                />
                            </div> : null}
                        {props.dashboardType === "IncidentManagement" || props.dashboardType === "SLA" ?
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={IncidentStatus}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.incident_status ? props.filterData.incident_status : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.incident_status)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('incident_status-select', e)}
                                />
                            </div> : null}
                        {props.dashboardType === "Capacity" || props.dashboardType === "Bot" || props.dashboardType === "SchedulingEfficiency" || props.dashboardType === "Remediation"
                            || props.dashboardType === "QueueEfficiency" || props.dashboardType === "QueueManagement" || props.dashboardType === "TrustIndex" || props.dashboardType === "Execution" || props.dashboardType === "BusinessViewValueRealization"
                            ?
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={Status}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.status ? props.filterData.status : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.status)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('status-select', e)}
                                />
                            </div> : null}
                        {props.dashboardType === "Execution" || props.dashboardType === "Capacity" || props.dashboardType === "Bot" || props.dashboardType === "SchedulingEfficiency" || props.dashboardType === "Remediation"
                            || props.dashboardType === "QueueEfficiency" || props.dashboardType === "QueueManagement" || props.dashboardType === "TrustIndex" || props.dashboardType === "BusinessViewValueRealization"
                            ?
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={AutomataState}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.automata_state ? props.filterData.automata_state : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.automata_state)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('automata_state-select', e)}
                                />
                            </div> : null}
                        {props.dashboardType === "IncidentManagement" || props.dashboardType === "SLA" ?
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={AssignmentGp}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.assignment_group ? props.filterData.assignment_group.filter(e => e.name) : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.assignment_group)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('assignment_group-select', e)}
                                />
                            </div> : null}
                        {props.dashboardType === "QueueEfficiency" || props.dashboardType === "QueueManagement" ?
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={QueueName}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.queue_name ? props.filterData.queue_name : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.queue_name)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('queue_name-select', e)}
                                />
                            </div> : null}
                        {props.dashboardType === "QueueEfficiency" || props.dashboardType === "QueueManagement" ?
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={JobId}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.job_id ? props.filterData.job_id : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.job_id)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('job_id-select', e)}
                                />
                            </div> : null}
                        {props.dashboardType === "QueueEfficiency" || props.dashboardType === "QueueManagement" ?
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={ItemStatusA1}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.itemStatus_A1 ? props.filterData.itemStatus_A1 : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.itemStatus_A1)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('itemStatus_A1-select', e)}
                                />
                            </div> : null}
                        {props.dashboardType === "Bot" || props.dashboardType === "Execution" || props.dashboardType === "Capacity" || props.dashboardType === "SchedulingEfficiency" || props.dashboardType === "Remediation" || props.dashboardType === "TrustIndex" || props.dashboardType === "Execution" || props.dashboardType === "BusinessViewValueRealization" ?
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={configConst.URL.includes(configConst.unilever) ? BotName : AutomataName}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.automata_activity_name ? props.filterData.automata_activity_name : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.automata_activity_name)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('automata_activity_name-select', e)}
                                />
                            </div> : null}
                        {props.dashboardType === "Bot" || props.dashboardType === "Execution" || props.dashboardType === "Capacity" ?
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={Resource}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.resource ? props.filterData.resource : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.resource)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('resource-select', e)}
                                />
                            </div> : null}
                        {props.dashboardType === "QueueEfficiency" || props.dashboardType === "QueueManagement" ?
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    titleText={AutomataName}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.automata_name ? props.filterData.automata_name : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.automata_name)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('automata_name-select', e)}
                                />
                            </div> : null}
                        {props.dashboardType === "QueueEfficiency" || props.dashboardType === "QueueManagement" || props.dashboardType === "SchedulingEfficiency" ||
                            props.dashboardType === "Remediation" || props.dashboardType === "TrustIndex" || props.dashboardType === "Capacity" || props.dashboardType === "Execution" || props.dashboardType === "BusinessViewValueRealization" ?
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    id='select'
                                    titleText={BotID}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.bot_id ? props.filterData.bot_id : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.bot_id)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('bot_id-select', e)}
                                />
                            </div> : null}
                        {configConst.URL.includes(configConst.unilever) ?
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    id='select'
                                    titleText={ProcessName}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.process_name ? props.filterData.process_name : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.process_name)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('process_name-select', e)}
                                />
                            </div> : null}
                        {props.dashboardType === "Remediation" ?
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    id='select'
                                    titleText={RemediationType}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={props.filterData && props.filterData.remediation_type ? props.filterData.remediation_type : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.remediation_type)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('remediation_type-select', e)}
                                />
                            </div> : null}
                    </div>
                </div> :
                (props.workspace === workspaces.sap_ops || props.workspace === workspaces.custom_ops) && filterSelections ?
                    <div className='filter-grid'>
                        <div className="multi-select-row">
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    id='select'
                                    titleText={franchise}
                                    helperText=''
                                    disabled={false}
                                    placeholder={Chooseoptions}
                                    items={franchiseItems ? franchiseItems : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.franchise)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={handleFranchiseSelectionChange}
                                />
                            </div>
                            <div className="multi-select-filter">
                                <MultiSelect.Filterable
                                    {...multiselectprops}
                                    id='client-select'
                                    key={clientKey}
                                    titleText={Client}
                                    helperText={Clientselection}
                                    disabled={disabledSelectsSAP}
                                    placeholder={Chooseoptions}
                                    items={clients ? clients : []}
                                    itemToString={(item) => (item ? item.name : '')}
                                    initialSelectedItems={populateInitalSelectedItems(filterSelections.client)}
                                    translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={multiselectprops.selectionFeedback}
                                    onChange={(e) => handleSelectionChange('client-select', e)}
                                />
                            </div>
                            {props.dashboardType !== "AlertManagement" && props.dashboardType !== "Bpmn" ?

                                <div className="multi-select-filter">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        titleText={Priority}
                                        helperText=''
                                        disabled={false}
                                        placeholder={Chooseoptions}
                                        items={props.filterData && props.filterData.priorities ? props.filterData.priorities : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(filterSelections.priority)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('priority-select', e)}
                                    />
                                </div> : null}
                            {props.dashboardType !== "AlertManagement" && props.dashboardType !== "Bpmn" ?
                                <div className="multi-select-filter">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        titleText={IncidentStatus}
                                        helperText=''
                                        disabled={false}
                                        placeholder={Chooseoptions}
                                        items={props.filterData && props.filterData.incident_status ? props.filterData.incident_status : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(filterSelections.incident_status)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('incident_status-select', e)}
                                    />
                                </div> : null}

                            {props.dashboardType !== "AlertManagement" && props.dashboardType !== "Bpmn" ?

                                <div className="multi-select-filter">
                                    <MultiSelect.Filterable
                                        {...multiselectprops}
                                        titleText={AssignmentGp}
                                        helperText=''
                                        disabled={false}
                                        placeholder={Chooseoptions}
                                        items={props.filterData && props.filterData.assignment_group && props.filterData.assignment_group.filter(e => e.name) ? props.filterData.assignment_group.filter(e => e.name) : []}
                                        itemToString={(item) => (item ? item.name : '')}
                                        initialSelectedItems={populateInitalSelectedItems(filterSelections.assignment_group)}
                                        translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                        selectionFeedback={multiselectprops.selectionFeedback}
                                        onChange={(e) => handleSelectionChange('assignment_group-select', e)}
                                    />
                                </div> : null}
                            {props.dashboardType === "Bpmn" ?
                                <>
                                    <div className="multi-select-filter">
                                        <MultiSelect.Filterable
                                            {...multiselectprops}
                                            titleText={"User"}
                                            helperText=''
                                            disabled={false}
                                            placeholder={Chooseoptions}
                                            items={props.filterData && props.filterData.bpmn_user && props.filterData.bpmn_user.filter(e => e.name) ? props.filterData.bpmn_user.filter(e => e.name) : []}
                                            itemToString={(item) => (item ? item.name : '')}
                                            initialSelectedItems={populateInitalSelectedItems(filterSelections.bpmn_user)}
                                            translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                            selectionFeedback={multiselectprops.selectionFeedback}
                                            onChange={(e) => handleSelectionChange('bpmn_user-select', e)}
                                        />
                                    </div>
                                    <div className="multi-select-filter">
                                        <MultiSelect.Filterable
                                            {...multiselectprops}
                                            titleText={"Report"}
                                            helperText=''
                                            disabled={false}
                                            placeholder={Chooseoptions}
                                            items={props.filterData && props.filterData.bpmn_report && props.filterData.bpmn_report.filter(e => e.name) ? props.filterData.bpmn_report.filter(e => e.name) : []}
                                            itemToString={(item) => (item ? item.name : '')}
                                            initialSelectedItems={populateInitalSelectedItems(filterSelections.bpmn_report)}
                                            translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                            selectionFeedback={multiselectprops.selectionFeedback}
                                            onChange={(e) => handleSelectionChange('bpmn_report-select', e)}
                                        />
                                    </div>
                                    <div className="multi-select-filter">
                                        <MultiSelect.Filterable
                                            {...multiselectprops}
                                            titleText={"Report Type"}
                                            helperText=''
                                            disabled={false}
                                            placeholder={Chooseoptions}
                                            items={props.filterData && props.filterData.bpmn_report_type && props.filterData.bpmn_report_type.filter(e => e.name) ? props.filterData.bpmn_report_type.filter(e => e.name) : []}
                                            itemToString={(item) => (item ? item.name : '')}
                                            initialSelectedItems={populateInitalSelectedItems(filterSelections.bpmn_report_type)}
                                            translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                            selectionFeedback={multiselectprops.selectionFeedback}
                                            onChange={(e) => handleSelectionChange('bpmn_report_type-select', e)}
                                        />
                                    </div>
                                </> : null}

                            {props.dashboardType === "AlertManagement" ?
                                <>
                                    <div className="multi-select-filter">
                                        <MultiSelect.Filterable
                                            {...multiselectprops}
                                            id='alert_source-select'
                                            titleText={AlertSource}
                                            helperText=''
                                            disabled={alertSourceSystemDisable}
                                            placeholder={Chooseoptions}
                                            items={alertSourceData ? alertSourceData : []}
                                            key={alertSourceKey}
                                            itemToString={(item) => (item ? item.name : '')}
                                            initialSelectedItems={populateInitalSelectedItems(filterSelections.alert_source)}
                                            translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                            selectionFeedback={multiselectprops.selectionFeedback}
                                            onChange={(e) => handleSelectionChange('alert_source-select', e)}
                                        />
                                    </div>
                                    <div className="multi-select-filter">
                                        <MultiSelect.Filterable
                                            {...multiselectprops}
                                            id='alert_system_name-select'
                                            titleText={SystemName}
                                            helperText=''
                                            disabled={alertSourceSystemDisable}
                                            placeholder={Chooseoptions}
                                            items={alertSystemNameData ? alertSystemNameData : []}
                                            key={alertSystemKey}
                                            itemToString={(item) => (item ? item.name : '')}
                                            initialSelectedItems={populateInitalSelectedItems(filterSelections.alert_system_name)}
                                            translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                            selectionFeedback={multiselectprops.selectionFeedback}
                                            onChange={(e) => handleSelectionChange('alert_system_name-select', e)}
                                        />
                                    </div>
                                </>
                                : null}
                        </div>

                    </div> : null}

            {props.workspace === workspaces.salesforce_ops && filterSelections ?
                <div className='filter-grid'>
                    <div className="multi-select-row">
                        <div className="multi-select-filter">
                            <MultiSelect.Filterable
                                {...multiselectprops}
                                id='select'
                                titleText={franchise}
                                helperText=''
                                disabled={false}
                                placeholder={Chooseoptions}
                                items={props.filterData && props.filterData.franchises ? props.filterData.franchises : []}
                                itemToString={(item) => (item ? item.name : '')}
                                initialSelectedItems={populateInitalSelectedItems(filterSelections.franchise)}
                                translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                selectionFeedback={multiselectprops.selectionFeedback}
                                onChange={handleFranchiseSelectionChange}
                            />
                        </div>
                        <div className="multi-select-filter">
                            <MultiSelect.Filterable
                                {...multiselectprops}
                                id='client-select'
                                titleText={Client}
                                key={clientKey}
                                helperText={Clientselection}
                                disabled={disabledSelectsSalesforce}
                                placeholder={Chooseoptions}
                                items={clients ? clients : []}
                                itemToString={(item) => (item ? item.name : '')}
                                initialSelectedItems={populateInitalSelectedItems(filterSelections.client)}
                                translateWithId={(id) => multiselectprops.listBoxMenuIconTranslationIds[id]}
                                selectionFeedback={multiselectprops.selectionFeedback}
                                onChange={(e) => handleSelectionChange('client-select', e)}
                            />
                        </div>
                    </div>
                </div> : null}

            <div className="dashboard-bottom-button">
                <div>
                    <Button kind='ghost' onClick={clearAll}>
                        {Clear}
                    </Button>
                    <Button kind='primary' onClick={handleFilterChange}>
                        {Apply}
                    </Button>
                </div>
            </div>
        </div>

    );
};
export default DashboardFilters;
